import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["smallViewportConfig", "styles", "makeStyles"];
var _dec, _class, _TopNavBarLayout;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { withStyle } from '@instructure/emotion';
import { TopNavBarContext } from "../TopNavBarContext.js";
import generateComponentTheme from "./theme.js";
import { TopNavBarSmallViewportLayout } from "./SmallViewportLayout/index.js";
import { TopNavBarDesktopLayout } from "./DesktopLayout/index.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
parent: TopNavBar
id: TopNavBar.Layout
---
@module TopNavBarLayout
**/
let TopNavBarLayout = (_dec = withStyle(null, generateComponentTheme), _dec(_class = (_TopNavBarLayout = class TopNavBarLayout extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    // TODO: Remove this in v10!
    if ('desktopConfig' in this.props) {}
  }
  get sortedThemeOverride() {
    const themeOverride = this.props.themeOverride;

    // TODO: try to type better, the themeOverride types are not prepared to be inherited and sorted

    if (!themeOverride || typeof themeOverride === 'function') {
      return {
        desktopThemeOverride: themeOverride,
        smallViewportThemeOverride: themeOverride
      };
    }
    const desktopThemeOverride = {};
    const smallViewportThemeOverride = {};
    for (const key in themeOverride) {
      if (key.startsWith('smallViewport')) {
        const variable = key;
        smallViewportThemeOverride[variable] = themeOverride[variable];
      } else if (key.startsWith('desktop')) {
        const variable = key;
        desktopThemeOverride[variable] = themeOverride[variable];
      }
    }
    return {
      desktopThemeOverride,
      smallViewportThemeOverride
    };
  }
  render() {
    const _this$props = this.props,
      smallViewportConfig = _this$props.smallViewportConfig,
      styles = _this$props.styles,
      makeStyles = _this$props.makeStyles,
      restProps = _objectWithoutProperties(_this$props, _excluded);
    if (this.context.layout === 'smallViewport') {
      return _jsx(TopNavBarSmallViewportLayout, {
        ...smallViewportConfig,
        ...restProps,
        themeOverride: this.sortedThemeOverride.smallViewportThemeOverride,
        elementRef: this.handleRef
      });
    }
    return _jsx(TopNavBarDesktopLayout, {
      ...restProps,
      themeOverride: this.sortedThemeOverride.desktopThemeOverride,
      elementRef: this.handleRef
    });
  }
}, _TopNavBarLayout.displayName = "TopNavBarLayout", _TopNavBarLayout.componentId = 'TopNavBar.Layout', _TopNavBarLayout.allowedProps = allowedProps, _TopNavBarLayout.defaultProps = {
  smallViewportConfig: {}
}, _TopNavBarLayout.contextType = TopNavBarContext, _TopNavBarLayout)) || _class);
export { TopNavBarLayout };
export default TopNavBarLayout;